import { Card } from '@/components/atoms';
import { CardContent } from '@/components/atoms/Card/Card';
import { Skeleton } from '@/components/atoms/Skeleton/Skeleton';
import { Survey_CARD_TEST_IDS } from '@/constants/data-testids';

export const SurveyCardSkeleton = () => {
  return (
    <Card
      data-testid={Survey_CARD_TEST_IDS.SKELETON}
      className="rounded-[12px] p-0 w-full h-[307px] overflow-hidden"
    >
      <CardContent>
        <div className="w-full h-[100px]">
          <Skeleton className="w-full h-full" />
        </div>
        <div className="px-[16px] py-[14px] w-full">
          <div className="flex items-center gap-1.5 justify-between h-[22px] mb-3">
            <Skeleton className="w-full h-[14px]" />
            <Skeleton className="w-full h-[14px]" />
            <Skeleton className="w-full h-[14px]" />
          </div>
          <div className="flex flex-col gap-2 w-full">
            <Skeleton className="w-full h-[14px]" />
            <Skeleton className="w-full h-[14px]" />
            <Skeleton className="w-4/5 h-[14px]" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
